const sentPayments = new Set();
const zeroDecimalCurrencies = new Set([
  'BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA',
  'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF',
]);

// Called only from the initial Stripe payment response, never from page/session restoration.
export function trackInitialGoogleAdsConversion(result) {
  const payment = result?.initialPayment;
  if (result?.success !== true || result.error || !payment) return;
  const { transaction_id, amount_received } = payment;
  const currency = typeof payment.currency === 'string' ? payment.currency.toUpperCase() : '';
  if (typeof transaction_id !== 'string' || !transaction_id.startsWith('pi_') ||
      !Number.isSafeInteger(amount_received) || amount_received <= 0 ||
      !/^[A-Z]{3}$/.test(currency || '') || typeof window.gtag !== 'function') return;

  const key = `google-ads-initial:${transaction_id}`;
  if (sentPayments.has(transaction_id)) return;
  try {
    if (localStorage.getItem(key)) return;
  } catch { /* Storage can be unavailable; retain in-memory deduplication. */ }

  const divisor = zeroDecimalCurrencies.has(currency) ? 1 :
    ['BHD', 'JOD', 'KWD', 'OMR', 'TND'].includes(currency) ? 1000 : 100;
  try {
    window.gtag('event', 'conversion', {
      send_to: 'AW-18428159167/6W4iCJLkvfkcEL_JndNE',
      value: amount_received / divisor,
      currency,
      transaction_id,
    });
    sentPayments.add(transaction_id);
    try { localStorage.setItem(key, '1'); } catch { /* Payment must continue. */ }
  } catch { /* Analytics must not interrupt a successful payment. */ }
}
